import React, { memo } from 'react'
import TableBody from '@mui/material/TableBody'
import TableCell from '@mui/material/TableCell'
import { Column } from '../../../../shared/types/Column'
import { StyledTableRow } from '../../../../shared/ui/StyledTableRow/StyledTableRow'
import {
	useAppSelector
} from '../../../../shared/lib/hooks/useAppSelector/useAppSelector'
import { LicenseUpdatesTableCellContent } from './LicenseUpdatesTableCellContent'
import { selectPaginatedItems } from '../../model/selectors/selectPaginatedItems'

interface LicenseUpdatesTableProps {
	columns: Column[]
}

export const LicenseUpdatesTable = memo((props: LicenseUpdatesTableProps) => {
	const { columns } = props
	const licenseUpdates = useAppSelector(selectPaginatedItems)

	return (
		<TableBody>
			{licenseUpdates.map((row, i) => (
				<StyledTableRow hover role="checkbox" tabIndex={-1} key={i}>
					{columns.map((column) => (
						<TableCell key={column.id} align={column.align}>
							<LicenseUpdatesTableCellContent
								columnId={column.id}
								value={row?.[column.id as keyof typeof row]}
							/>
						</TableCell>
					))}
				</StyledTableRow>
			))}
		</TableBody>
	)
})
